// @ts-nocheck
import { request as requester } from 'sonata-react-components';
import { ScheduleReportInterface } from 'sonata-static-storage/lib/schemas/scheduleReport/scheduleReport.schema';

export async function saveScheduleReports(
  data: Omit<ScheduleReportInterface, '_id'>,
  requestToken: Record<string, any>
) {
  return requester.makeRequest(
    `${taptap.config.backendUrlBase}report/scheduleReport`,
    {
      data,
      method: 'POST'
    },
    requestToken
  );
}

export async function updateScheduleReports(
  scheduleReportId: string,
  data: Partial<ScheduleReportInterface>,
  requestToken: Record<string, any>
) {
  return requester.makeRequest(
    `${taptap.config.backendUrlBase}report/scheduleReport/${scheduleReportId}`,
    {
      data,
      method: 'PUT'
    },
    requestToken
  );
}

export async function storeNewReportTemplate(
  data: Record<string, any>,
  userId: string,
  requestToken: Record<string, any>
) {
  return requester.makeRequest(
    `${taptap.config.backendUrlBase}report/template/${userId}/undefined`,
    {
      data,
      method: 'POST'
    },
    requestToken
  );
}

export async function updateReportTemplate(
  reportTemplateId: string,
  data: Record<string, any>,
  userId: string,
  requestToken: Record<string, any>
) {
  return requester.makeRequest(
    `${taptap.config.backendUrlBase}report/template/${userId}/${reportTemplateId}`,
    {
      data,
      method: 'PUT'
    },
    requestToken
  );
}
